import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from '../../styles/Sidebar.module.scss';
import { assetUrl } from '../../utils/imageUrl';
import { getNewestProducts } from '../../utils/newProducts';
import CarouselNav from '../common/CarouselNav';
import ProductImage from '../common/ProductImage';
import { getProductUrl } from '../../utils/urls';

const formatPrice = (price) => `${Number(price).toLocaleString('uk-UA')} ₴`;

const NewProductsCarousel = () => {
  const { list: products } = useSelector((state) => state.products);
  const [index, setIndex] = useState(0);

  const newestProducts = useMemo(() => getNewestProducts(products), [products]);

  useEffect(() => {
    if (index >= newestProducts.length) {
      setIndex(0);
    }
  }, [index, newestProducts.length]);

  useEffect(() => {
    setIndex(0);
  }, [newestProducts[0]?.id]);

  if (!newestProducts.length) return null;

  const safeIndex = index >= newestProducts.length ? 0 : index;
  const product = newestProducts[safeIndex];
  const hasMultiple = newestProducts.length > 1;

  const goPrev = () => {
    setIndex((prev) => (prev <= 0 ? newestProducts.length - 1 : prev - 1));
  };

  const goNext = () => {
    setIndex((prev) => (prev >= newestProducts.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className={styles.novinki}>
      <div className={styles.novinkiHeader}>
        <span className={styles.novinkiTitle}>НОВИНКИ</span>
      </div>

      <div className={`${styles.novinkiCard}${hasMultiple ? ` ${styles.novinkiCardWithNav}` : ''}`}>
        <div className={styles.novinkiCardBody}>
          <div className={styles.novinkiImageWrap}>
            <Link to={getProductUrl(product)} className={styles.novinkiImageLink}>
              {product.images?.[0] ? (
                <ProductImage
                  src={assetUrl(product.images[0])}
                  alt={product.title}
                  width={120}
                  height={120}
                />
              ) : (
                <div className={styles.novinkiImagePlaceholder} />
              )}
            </Link>
          </div>

          <Link to={getProductUrl(product)} className={styles.novinkiProductTitle}>
            {product.title}
          </Link>
          <div className={styles.novinkiPrice}>{formatPrice(product.price)}</div>
        </div>

        {hasMultiple && (
          <CarouselNav
            className={styles.novinkiCarouselNav}
            total={newestProducts.length}
            current={safeIndex}
            onPrev={goPrev}
            onNext={goNext}
            onDotClick={setIndex}
          />
        )}
      </div>
    </div>
  );
};

export default NewProductsCarousel;
